import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar';
import Awards from './components/Awards';
import Hero from './components/Hero';
import FastCare from './components/FastCare';
import Services from './components/Services';
import Insurance from './components/Insurance';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import CallToAction from './components/CallToAction';
import Footer from './components/Footer';
import ServicesPage from './pages/ServicesPage';
import ProvidersPage from './pages/ProvidersPage';
import AboutPage from './pages/AboutPage';
import CareersPage from './pages/CareersPage';
import PrimaryCare from './pages/PrimaryCare';
import UrgentCare from './pages/UrgentCare';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Compliance from './pages/Compliance';
import HIPAA from './pages/HIPAA';
import Physicals from './pages/Physicals';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faClock, faUserMd, faHeartbeat, faStethoscope, faSyringe, faXRay, faProcedures, faMapMarkerAlt, faPhone } from '@fortawesome/free-solid-svg-icons';

// Add icons to the library so they can be used throughout the app
library.add(faClock, faUserMd, faHeartbeat, faStethoscope, faSyringe, faXRay, faProcedures, faMapMarkerAlt, faPhone);

function Home() {
  return (
    <main>
      <Hero />
      <FastCare />
      <Services />
      <Insurance />
      <Testimonials />
      <FAQ />
      <CallToAction />
    </main>
  );
}

function App() {
 // const [scriptLoaded, setScriptLoaded] = useState(false);
 // const [scriptError, setScriptError] = useState(null);

  // Moved ScrollToTop inside App to have access to useLocation
  function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  }

  // useEffect(() => {
  //   let script = document.querySelector('script[src*="elevenlabs"]');
    
  //   if (!script) {
  //     script = document.createElement('script');
  //     script.src = "https://unpkg.com/@elevenlabs/convai-widget-embed@beta";
  //     script.async = true;
      
  //     script.onload = () => {
  //       console.log('ElevenLabs widget script loaded successfully');
  //       setScriptLoaded(true);
  //     };
      
  //     script.onerror = (error) => {
  //       console.error('Error loading ElevenLabs widget:', error);
  //       setScriptError('Failed to load voice agent. Please refresh the page to try again.');
  //     };
      
  //     document.body.appendChild(script);
  //   } else if (window.elevenlabs) {
  //     setScriptLoaded(true);
  //   }

  //   return () => {
  //     const widget = document.querySelector('elevenlabs-convai');
  //     if (widget) {
  //       widget.remove();
  //     }
  //   };
  // }, []);

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Navbar />
        <Awards />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/primary-care" element={<PrimaryCare />} />
          <Route path="/urgent-care" element={<UrgentCare />} />
          <Route path="/providers" element={<ProvidersPage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/hipaa" element={<HIPAA />} />
          <Route path="/physicals" element={<Physicals />} />
        </Routes>
        
        {/* ElevenLabs Voice Agent Widget */}
        {/* {scriptLoaded && !scriptError && (
          <elevenlabs-convai agent-id="agent_9701kbxfa3yrftrvhw55v2nf2gyz"></elevenlabs-convai>
        )} */}
        
        {/* {scriptError && (
          <div style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            padding: '10px 20px',
            backgroundColor: '#f8d7da',
            color: '#721c24',
            borderRadius: '4px',
            zIndex: 1000
          }}>
            {scriptError}
          </div>
        )} */}
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;